import React, {createContext, ReactNode, useState} from 'react';

type AudioCaptionsContext = {
  captions: string | null;
};

type AudioCaptionsActionsContext = {
  setCaptions: (caption: string | null) => void;
};

const AudioCaptionsContextInstance = createContext<AudioCaptionsContext | null>(null);
const AudioCaptionsActionsContextInstance = createContext<AudioCaptionsActionsContext | null>(null);

export const AudioCaptionsContextProvider = (props: { children?: ReactNode }) => {
  const [captions, setCaptions] = useState<string | null>(null);

  return (
    <AudioCaptionsContextInstance.Provider value={{ captions }}>
      <AudioCaptionsActionsContextInstance.Provider value={{ setCaptions }}>
        {props.children}
      </AudioCaptionsActionsContextInstance.Provider>
    </AudioCaptionsContextInstance.Provider>
  );
};

/**
 * Returns a context containing current audio captions.
 */
export const useAudioCaptionsContext = () => {
  const context = React.useContext(AudioCaptionsContextInstance);
  if (context) {
    return context;
  }
  throw Error('Audio captions context is missing.');
};

/**
 * Returns a context with functions to modify the current context.
 */
export const useAudioCaptionsActionsContext = () => {
  const context = React.useContext(AudioCaptionsActionsContextInstance);
  if (context) {
    return context;
  }
  throw Error('Audio captions context is missing.');
};
